<template>
  <SimpleTextPopup
    :title="$t('expenseHistory')"
    v-model="value"
    @popupClose="$emit('input', false)"
    :hideRgtBtn="true"
    medium
  >
    <template v-slot:input>
      <v-data-table
        :headers="historyHeaders"
        :items="expenseHistoryReversion"
        class="elevation-2 myDense"
      >
        <template v-slot:items="props">
            <td class="subheading">{{ props.index + 1}}</td>
            <td class="text-xs-left">{{ props.item.dateKeyStr }}</td>
            <td class="text-xs-left">{{ props.item.expense }}</td>
        </template>
      </v-data-table>
    </template>
  </SimpleTextPopup>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'

export default {
  name: 'ExpenseHistoryPopup',
  components: {
    SimpleTextPopup
  },
  data () {
    return {
      historyHeaders: [
        { text: this.$t('id#'), align: 'left', sortable: false, value: 'key' },
        { text: this.$t('date'), value: 'dateKeyStr', align: 'left', sortable: false },
        { text: this.$t('expense'), value: 'expense', align: 'left', sortable: false }
      ]
    }
  },
  computed: {
    expenseHistoryReversion () {
      return [...(this.expenseHistory || [])].sort((a, b) => {
        const formattedDateA = `${a.dateKeyStr.split('-')[0]}-${a.dateKeyStr.split('-')[1].padStart(2, '0')}`
        const formattedDateB = `${b.dateKeyStr.split('-')[0]}-${b.dateKeyStr.split('-')[1].padStart(2, '0')}`
        return new Date(formattedDateB) - new Date(formattedDateA)
      })
    }
  },
  props: {
    value: Boolean,
    expenseHistory: Array
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExpenseHistoryPopup.vue